
export const DEFAULT_ERROR_MSG = 'Something went wrong. Please try again later!';

/* Dynamically generates CSS color properties depending on alert severityn*/ 
export const getAlertSeverityColors= (severity: string) =>{
    let alertSeverityColor;
    switch (severity) {
        case 'success':
            alertSeverityColor = {textColor: '#0aff15', backgroundColor: '#ffffff' };
            break;
        case 'error': 
            alertSeverityColor = {textColor: '#dd0603', backgroundColor: '#ffffff' };
            break;
        default:
            alertSeverityColor = {}
    }
    return alertSeverityColor;
}